<template>
  <div class="row recursive-row" v-show="show">
    <div class="col-sm-9 col-md-4 ellipsis-text align-self-center">
      <indented-span :level="level + 1" :hasHighlight="searchMatchesName">
        {{ user.description }}
      </indented-span>
      <active-tag
        class="d-md-none"
        :isActive="user.is_active"
        :isConfirmed="user.is_confirmed"
      />
    </div>
    <div class="col-md-2 d-none d-md-block align-self-center">
      <role-tag :role="{ id: 'machine', name: 'Machine' }" />
    </div>
    <div
      :class="{
        'text-success': searchMatchesClientId,
        'font-weight-bold': searchMatchesClientId
      }"
      class="col-md-3 d-none d-md-block ellipsis-text align-self-center"
    >
      {{ user.client_id }}
    </div>
    <active-column
      :isActive="user.is_active"
      :isConfirmed="user.is_confirmed"
    />
    <div class="col-sm-2 text-right align-self-center">
      <button class="btn btn-sm" @click="selectUser">Select</button>
    </div>
  </div>
</template>

<script>
import IndentedSpan from "../IndentedSpan.vue";
import ActiveTag from "../Tags/ActiveTag.vue";
import ActiveColumn from "./ActiveColumn.vue";
import RoleTag from "../Tags/RoleTag.vue";
import config from "../../constants/config";

export default {
  components: {
    ActiveColumn,
    ActiveTag,
    IndentedSpan,
    RoleTag
  },
  name: "MachineUserRow",
  props: {
    user: Object,
    group: Object,
    level: Number,
    searchTerm: String,
    hideForParent: Boolean
  },
  data() {
    return {
      hideForSearch: false
    };
  },
  methods: {
    selectUser() {
      this.$store.commit("user/selectMachineUser", {
        ...this.user,
        group: this.group
      });
      this.$bvModal.show(config.MACHINE_USER_MODAL_ID);
    }
  },
  computed: {
    searchMatchesClientId() {
      return (
        this.searchTerm != "" &&
        this.user.client_id
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase())
      );
    },
    searchMatchesName() {
      return (
        this.searchTerm != "" &&
        this.user.description
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase())
      );
    },
    show() {
      return !this.hideForParent && !this.hideForSearch;
    }
  },
  watch: {
    searchTerm(newTerm) {
      if (!newTerm) {
        this.hideForSearch = false;
      } else if (this.searchMatchesClientId || this.searchMatchesName) {
        this.$emit("searchFound", newTerm);
        this.hideForSearch = false;
      } else {
        this.hideForSearch = true;
      }
    }
  }
};
</script>
